"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
var _ar = _interopRequireDefault(require("./flags/ar.svg"));
var _es = _interopRequireDefault(require("./flags/es.svg"));
var _missing = _interopRequireDefault(require("./flags/missing.svg"));
var _us = _interopRequireDefault(require("./flags/us.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Flag = _ref => {
  var _flagMap$country$toLo;
  let {
    borderColor,
    borderRadius = '4px',
    country = '--'
  } = _ref;
  const spanProps = {
    borderColor,
    borderRadius
  };
  const flagMap = {
    ar: _ar.default,
    es: _es.default,
    us: _us.default
  };
  const currentFlag = (_flagMap$country$toLo = flagMap[country.toLocaleLowerCase()]) !== null && _flagMap$country$toLo !== void 0 ? _flagMap$country$toLo : _missing.default;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.FlagContainer, _objectSpread(_objectSpread({}, spanProps), {}, {
    "data-testid": "FlagContainer",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      alt: "flag-".concat(country),
      src: currentFlag
    })
  }));
};
Flag.propTypes = {
  borderColor: _propTypes.default.string,
  borderRadius: _propTypes.default.string,
  country: _propTypes.default.oneOf(['--', 'AR', 'ES', 'US'])
};
var _default = exports.default = Flag;